module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-main', {
    staticClass: "login"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "data-qa": "Content-SigninLogo-Image",
      "src": "/src/assets/img/admin-logo.png"
    }
  }), _vm._v(" "), (_vm.resetPwdMsg) ? _c('el-col', {
    staticClass: "reset-pwd-msg",
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "reset-title",
    attrs: {
      "data-qa": "Content-SigninResetPwdMsg-Title"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('loginResetResponseTitle')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "reset-body",
    attrs: {
      "data-qa": "Content-SigninResetPwdMsg-Body"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('loginResetResponseMessage')) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "login-form",
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('loginFormTitle')))]), _vm._v(" "), _c('el-form', {
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('email') ? _vm.errors.first('email') : '',
      "show-message": _vm.errors.has('email'),
      "prop": "email"
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "placeholder": _vm.$t('loginInputEmailPlaceholder'),
      "clearable": "",
      "data-qa": "Content-SigninEmail-Input",
      "name": "email",
      "type": "text",
      "data-vv-as": _vm.$t('loginInputEmailPlaceholder')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.validateForm($event)
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-open email",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('password') ? _vm.errors.first('password') : '',
      "show-message": _vm.errors.has('password'),
      "prop": "password"
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:8|max:20'),
      expression: "'required|min:8|max:20'"
    }],
    attrs: {
      "placeholder": _vm.$t('loginInputPasswordPlaceholder'),
      "clearable": "",
      "data-qa": "Content-SigninPassword-Input",
      "name": "password",
      "type": "password",
      "data-vv-as": _vm.$t('loginInputPasswordPlaceholder')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.validateForm($event)
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }, [_c('i', {
    staticClass: "fa fa-unlock-alt password",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  })])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "disabled": _vm.loading || _vm.errors.any(),
      "loading": _vm.loading,
      "data-qa": "Content-Signin-Button",
      "id": "signIn",
      "type": "primary"
    },
    on: {
      "click": _vm.validateForm
    }
  }, [_vm._v(_vm._s(_vm.$t('loginButtonSignInText')))])], 1), _vm._v(" "), _c('a', {
    staticClass: "forgot-pwd",
    attrs: {
      "data-qa": "Content-SigninForgotPassword-Link",
      "type": "text"
    },
    on: {
      "click": _vm.forgetPwd
    }
  }, [_vm._v(_vm._s(_vm.$t('loginLinkForgotPasswordText')))])], 1)], 1), _vm._v(" "), (_vm.response) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-card', [_c('div', {
    attrs: {
      "slot": "header",
      "data-qa": "Content-SigninError-Title"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('loginErrorResponseTitle')))]), _vm._v(" "), _c('div', {
    attrs: {
      "data-qa": "Content-SigninError-Body"
    }
  }, [_vm._v(_vm._s(_vm.response))])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-337eee44","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/Login.vue
// module id = 962
// module chunks = 3